import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {ITeacherAttachmentData} from "../../../contracts/data/teacher";
import {TeacherAttachmentType} from "../../../constans/enumTypes";
import {teachersApi} from "../../../constans/apiUrls";
import InnerTeacherAttachmentForm from "../../../components/FormTemplates/teacher/InnerTeacherAttachmentForm";
import {isNotEmpty} from "../../../helpers/functions";


const teacherAttachmentFormValidationSchema = yup.object().shape({
    attachment: yup.string().required("فایل الزامی میباشد"),
})

interface ITeacherAttachmentFormProps {
    formType?: string,
    prevData?: ITeacherAttachmentData,
    teacherId: number,
    handleChange: (data: ITeacherAttachmentData) => void
}

const TeacherAttachmentForm = withFormik<ITeacherAttachmentFormProps, ITeacherAttachmentData>({
    mapPropsToValues: props => ({
        id: props?.prevData ? props?.prevData?.id : 0,
        teacher: (props?.prevData && props?.prevData?.teacher > 0) ? props?.prevData?.teacher : props?.teacherId,
        attachment: props?.prevData ? props?.prevData?.attachment : '',
        attachment_url: props?.prevData ? props?.prevData?.attachment_url : '',
        type: props?.prevData ? props?.prevData?.type : TeacherAttachmentType.FILE,
        is_active: props?.prevData ? props?.prevData?.is_active : true
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: teacherAttachmentFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.attachment && isNotEmpty(values.attachment) && typeof values.attachment === 'object') {
            formData.append('attachment', values.attachment)
        }
        formData.append('data', JSON.stringify(values));
        if (formikBag.props.formType === 'create') {
            await httpClient().post(teachersApi.attachment_create, formData)
                .then(response => {
                    if(response.status === 201 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                        formikBag.props.handleChange(response?.data?.data)
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error?.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            await httpClient().put(`${teachersApi.attachment_update}/${values.id}`, formData)
                .then(response => {
                    if(response.status === 200){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                        formikBag.props.handleChange(response?.data?.data)
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error?.response.data
                }))
        }
    },
    displayName: 'TeacherAttachmentForm'
})(InnerTeacherAttachmentForm)

export default TeacherAttachmentForm